<template>
  <section class="w-full space-y-1 text-center">
    <slot></slot>
    <div
      class="text-text-neutral-primary flex justify-center space-x-1 text-lg font-bold"
    >
      <template v-if="remainingTime.days > 0">
        <div class="flex space-x-1">
          <p>{{ remainingTime.days }}</p>
          <p>{{ t('countdownTimer.days', remainingTime.days) }}</p>
        </div>
        <p>&nbsp;</p>
      </template>
      <template v-if="remainingTime.hours > 0">
        <div class="flex space-x-1">
          <p>{{ remainingTime.hours }}</p>
          <p>{{ t('countdownTimer.hour') }}</p>
        </div>
        <p>:</p>
      </template>
      <div class="flex space-x-1">
        <p>{{ remainingTime.minutes }}</p>
        <p>{{ t('countdownTimer.min') }}</p>
      </div>
      <p>:</p>
      <div class="flex space-x-1">
        <p>{{ remainingTime.seconds }}</p>
        <p>{{ t('countdownTimer.sec') }}</p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';

  import messages from '../config/locales.json';
  import { useTimer } from '../model';

  const props = defineProps<{
    expiresAt: string;
  }>();
  const emit = defineEmits<{ onExpired: [] }>();

  const { t } = useI18n({ messages });
  const timer = useTimer(() => emit('onExpired'));
  const remainingTime = computed(() => {
    return {
      days: timer.state.value.days,
      hours: timer.state.value.hours,
      minutes: timer.state.value.minutes,
      seconds: timer.state.value.seconds,
    };
  });

  onMounted(() => timer.launchTimer(props.expiresAt));
</script>
